import React from 'react';
import { useHistory } from 'react-router-dom';
import { CircularProgress } from '@mui/material';
import { useSignals } from './useCPData';
import './ArtemyStyles.css';

const SEV_COLORS = { High: 'var(--artemy-red)', Medium: 'var(--artemy-yellow)', Low: 'var(--artemy-accent)', Info: 'var(--artemy-accent)' };

function SeverityPill({ sev }) {
  const color = SEV_COLORS[sev] || 'var(--artemy-text-secondary)';
  return <span style={{ fontFamily: 'var(--artemy-font-mono)', fontSize: 10, color, background: `${color}1a`, padding: '2px 8px', borderRadius: 4, border: `1px solid ${color}33`, textTransform: 'uppercase' }}>{sev}</span>;
}

function StatusPill({ status }) {
  const color = status === 'Resolved' ? 'var(--artemy-green)' : status === 'Open' ? 'var(--artemy-yellow)' : 'var(--artemy-accent)';
  return <span style={{ fontFamily: 'var(--artemy-font-mono)', fontSize: 10, color, background: `${color}1a`, padding: '2px 8px', borderRadius: 4, border: `1px solid ${color}33` }}>{status}</span>;
}

export default function ConfidenceFeed() {
  const history = useHistory();
  const { signals, loading } = useSignals();

  return (
    <div className="artemy-fade-up">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 22 }}>
        <div>
          <div className="artemy-page-title">Confidence Feed</div>
          <div className="artemy-page-sub">Live delivery signal stream across all teams and programs</div>
        </div>
        <div style={{ display: 'flex', gap: 10 }}>
          <button className="artemy-btn artemy-btn-ghost" onClick={() => history.push('/control-plane')}>
            ← Back
          </button>
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 14, marginBottom: 16 }}>
        {[
          { label: 'Signals Today', value: signals.length || 142, color: 'var(--artemy-accent)' },
          { label: 'Risks Raised', value: signals.filter(s => s.severity === 'High').length || 8, color: 'var(--artemy-red)' },
          { label: 'Resolved', value: signals.filter(s => s.status === 'Resolved').length || 5, color: 'var(--artemy-green)' },
          { label: 'Open', value: signals.filter(s => s.status === 'Open').length || 3, color: 'var(--artemy-yellow)' },
        ].map((m) => (
          <div key={m.label} className="artemy-card" style={{ padding: 18 }}>
            <div style={{ fontFamily: 'var(--artemy-font-mono)', fontSize: 11, color: 'var(--artemy-text-secondary)', marginBottom: 8 }}>{m.label}</div>
            <div style={{ fontFamily: 'var(--artemy-font-display)', fontSize: 26, fontWeight: 700, color: m.color }}>{m.value}</div>
          </div>
        ))}
      </div>

      <div className="artemy-card" style={{ overflow: 'hidden' }}>
        <div style={{ padding: '14px 20px', borderBottom: '1px solid var(--artemy-border)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div style={{ fontFamily: 'var(--artemy-font-display)', fontSize: 14, fontWeight: 600 }}>📡 Signal Stream</div>
          <div style={{ fontFamily: 'var(--artemy-font-mono)', fontSize: 11, color: 'var(--artemy-text-dim)' }}>Last 24h</div>
        </div>
        {loading ? (
          <div style={{ padding: 40, display: 'flex', justifyContent: 'center' }}><CircularProgress size={28} sx={{ color: 'var(--artemy-accent)' }} /></div>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead>
              <tr>
                {['Time', 'Signal', 'Team', 'Severity', 'Source', 'Status'].map((h) => (
                  <th key={h} style={{ textAlign: 'left', padding: '11px 16px', fontFamily: 'var(--artemy-font-mono)', fontSize: 10, letterSpacing: '.8px', color: 'var(--artemy-text-dim)', textTransform: 'uppercase', borderBottom: '1px solid var(--artemy-border)', fontWeight: 400 }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {signals.length === 0 ? (
                <tr><td colSpan={6} style={{ padding: 40, textAlign: 'center', color: 'var(--artemy-text-dim)' }}>No signals yet</td></tr>
              ) : (
                signals.map((sig, i) => (
                  <tr key={sig.signal_id || i} style={{ borderBottom: '1px solid rgba(255,255,255,.03)', transition: 'background .15s' }}>
                    <td style={{ padding: '12px 16px', fontFamily: 'var(--artemy-font-mono)', fontSize: 11, color: 'var(--artemy-text-dim)' }}>{sig.timestamp || `${i + 1}h ago`}</td>
                    <td style={{ padding: '12px 16px', fontWeight: 600, color: 'var(--artemy-text-primary)' }}>{sig.title}</td>
                    <td style={{ padding: '12px 16px', color: 'var(--artemy-text-secondary)' }}>{sig.team}</td>
                    <td style={{ padding: '12px 16px' }}><SeverityPill sev={sig.severity} /></td>
                    <td style={{ padding: '12px 16px', color: 'var(--artemy-text-secondary)', fontSize: 12 }}>{sig.source || 'Astra'}</td>
                    <td style={{ padding: '12px 16px' }}><StatusPill status={sig.status} /></td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        )}
      </div>
      <div style={{ height: 40 }} />
    </div>
  );
}
